import { RootStateOrAny, useSelector } from 'react-redux';

import { PlacementsState } from './reducer';

export const selectPlacements = ({ placements }: RootStateOrAny): PlacementsState => placements;

export const usePlacements = () => useSelector(selectPlacements);
